module.exports = __webpack_public_path__ + "img/vimc diamond2.7d1462a7.png";